import $ from 'jquery';
import JQueryView, { on } from '@/common/views/jqueryView';

export default class AboutShareholderCommunityView extends JQueryView {
  constructor() {
    super('.about_shareholder_community');
  }

  @on({ event: 'click', selector: '.toggle-wrapper' })
  onClickToggleAnswer(event: JQuery.ClickEvent<HTMLDivElement>) {
    const id = event.currentTarget.dataset.answerId;
    $(`#${id}`).slideToggle();
    $(event.currentTarget).find('i').toggleClass('fa-plus');
    $(event.currentTarget).find('i').toggleClass('fa-minus');
  }
}
